var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',{staticClass:"mt-1 mb-25 font-weight-bolder"},[_c('b-avatar',{staticClass:"m-auto",attrs:{"variant":("light-" + _vm.color),"size":"40","text":_vm.statistic}})],1),_c('span',[_vm._v(_vm._s(_vm.statisticTitle))])])}
var staticRenderFns = []

export { render, staticRenderFns }